<template>
  <v-row justify="center">
    <template>
      <v-btn color="white" @click="click">
        <v-icon class="grey--text">mdi-map-marker-radius</v-icon>
      </v-btn>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'CassMapping',
  props: {
    documentId: {
      type: String,
      default: 'EhE7o1faLNMEu0GOPevu'
    }
  },
  data() {
    return {
      map: 'https://www.google.com/maps/place/',
      fullUrl: ''
    }
  },
  computed: {
    orderDetail() {
      if (this.documentId) {
        return this.$store.getters['order/orderAfterFilter'].filter(
          (order) => order.documentId === this.documentId
        )[0]
      } else {
        return this.$store.state.order.sample[0]
      }
    }
  },
  methods: {
    click() {
      this.cord = this.orderDetail.customer.location.cord
      this.direction = this.cord.latitude + ',' + this.cord.longitude
      this.fullUrl = this.map + this.direction
      window.open(this.fullUrl)
    }
  }
}
</script>

<style scoped></style>
